import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, useTheme } from "@mui/material";
/**
 * Displays an ingredient that has been replaced by another.
 * The original ingredient name is shown with a line-through to indicate it has been replaced, followed by
 * the name of the replacement ingredient. The component allows for conditional coloring of the text based
 * on the `inMainIngredientList` prop and can conditionally append a comma for list formatting.
 *
 * @param {string} ingredientName - The name of the original ingredient that has been replaced.
 * @param {string} replacementIngredient - The name of the ingredient used as a replacement.
 * @param {boolean} shouldAppendComma - Determines whether a comma should be appended after the replacement ingredient.
 * @param {boolean} inMainIngredientList - If set to true, the text color is changed to signify the replacement status of the ingredient.
 *
 */
export const ReplacementIngredient = ({ ingredientName, replacementIngredient, shouldAppendComma, inMainIngredientList }) => {
    const theme = useTheme();
    if (!replacementIngredient)
        return _jsx(_Fragment, {});
    const textColor = inMainIngredientList ? theme.palette.error.main : "inherit";
    return (_jsxs(Typography, Object.assign({ variant: "body1", component: "span", style: { color: textColor } }, { children: [_jsx(Typography, Object.assign({ sx: { textDecorationLine: "line-through", color: textColor }, variant: "body1", component: "span" }, { children: ingredientName })), " replaced with " + replacementIngredient + (shouldAppendComma ? "" : ", ")] })));
};
